import { Accordion, AccordionItem } from "@heroui/accordion";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import {
  useCalculateExpectedScoreMutation,
  useCalculateKraScoreMutation,
  useGetManagementReviewQuery,
} from "../../../../api/employeeApi";
import {
  useGetHODScoreRecommwndationQuery,
  useHODAppraisalReviewMutation,
} from "../../../../api/hrApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import bull from "../../../assets/bull.png";
import flag from "../../../assets/finish-FLAG.png";
import person from "../../../assets/personAppraisal.png";
import PageLayout from "../../../Components/Layout/PageLayout";
import { MetaData } from "../../Employee/SelfAppraisal/data";
import ApproveModal from "../../HR/Appraisal/Modals/ApproveModal";
import { MeasurementTypeFormatter } from "../../HR/Appraisal/Modals/data";
import { AppraisalDeclineModal } from "../../HR/Appraisal/Modals/DeclineModal";
import {
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import AppraisalReviewDetails from "../../Employee/SelfAppraisal/reviewDetails";
export const ViewManagementAppraisal = () => {
  const { id } = useParams();
  const { data } = useGetManagementReviewQuery(id);
  const allObjectives = data?.responseObject?.objectives || [];
  const employeeData = data?.responseObject?.employee;
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] = useHODAppraisalReviewMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const { data: recommendation } = useGetHODScoreRecommwndationQuery({
    ApprovalStatus: 0,
    PageNumber: 1,
    PageSize: 1000,
  });
  console.log('reccomendataion', recommendation)
  const initialized = React.useRef(false);
  const debounceRef = React.useRef(null);
  const debounceExpected = React.useRef(null);
  const [totalScore, setTotalScore] = useState({
    colorType: "",
    totalAppraisalScore: 0,
    performanceStatusLabelName: "",
  });
  const [maxScore, setMaxScore] = useState(0);
  const declineAction = async () => { };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;
  const submit = async (data) => {
    try {
      const payload = {
        referenceId: id,
        isAccepted: true,
        comment: data.comment,
        selectedRecommendation: data.selectedRecommendation,
        requiresPip: true,
      };
      const response = await approveDecline(payload).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/management/Management-Appraisal-HOD");
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage ?? "Error approving rating scale");
    }
  };
  const [onCalculate] = useCalculateKraScoreMutation();
  const [expectedScore] = useCalculateExpectedScoreMutation();
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      return;
    }

    if (!allObjectives.length) return;
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(async () => {
      try {
        const objectives = allObjectives.map((objective, objIndex) => {
          const krAs = objective.krAs.map((kra, kraIndex) => {
            const actualScore =
              kra?.employeeReviewDetails?.find(
                (item) => item.appraisalType === 1
              )?.kraActualScore || 0;
            return {
              kraId: kra.kraId,
              actualValue: parseInt(actualScore) || 0,
              targetValue: kra.targetValue || 0.01,
              weight: kra.weight,
            };
          });
          return {
            objectiveId: objective.objectiveId,
            objectiveWeight: objective.objectiveWeight,
            krAs,
          };
        });

        const res = await onCalculate({
          employeeId: employeeData?.id || 0,
          referenceId: id,
          objectives,
        }).unwrap();
        if (res) {
          setTotalScore({
            colorType: res.colorType,
            totalAppraisalScore: res.totalAppraisalScore,
            performanceStatusLabelName: res.performanceStatusLabelName,
          });
        }
      } catch (err) {
        console.error("Error calculating total actual score:", err);
      }
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [employeeData?.id, id, onCalculate, formMethods, allObjectives]);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      return;
    }

    if (!allObjectives.length) return;
    if (debounceExpected.current) {
      clearTimeout(debounceExpected.current);
    }
    debounceExpected.current = setTimeout(async () => {
      try {
        const objectives = allObjectives.map((objective) => {
          const krAs = objective.krAs.map((kra) => {
            return {
              kraId: kra.kraId,
              actualValue: kra.targetValue || 0,
              targetValue: kra.targetValue || 0.01,
              weight: kra.weight,
            };
          });
          return {
            objectiveId: objective.objectiveId,
            objectiveWeight: objective.objectiveWeight,
            krAs,
          };
        });

        const res = await expectedScore({
          employeeId: employeeData?.id || 0,
          referenceId: id,
          objectives,
        }).unwrap();
        if (res) {
          setMaxScore(res.totalAppraisalScore);
        }
      } catch (err) {
        console.error("Error calculating total actual score:", err);
      }
    }, 500);

    return () => {
      if (debounceExpected.current) {
        clearTimeout(debounceExpected.current);
      }
    };
  }, [employeeData?.id, id, expectedScore, formMethods, allObjectives]);
  const employeeType = employeeData?.employementStatus?.toLowerCase() === "confirmed"
    ? 2 : 1
  return (
    <PageLayout title={"Appraisal Review Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}></div>
      <div>
        <span className={`text-[${totalScore.colorType}] font-[600]`}>
          Total Score: {totalScore.totalAppraisalScore}/{maxScore} (
          {totalScore.totalAppraisalScore / maxScore ?? 0})%
        </span>
      </div>
      <div>
        <div className={DashboardStyle.view_app_components}>
          <div className="mb-4"></div>
          <Accordion
            aria-label={`Accordion 1`}
            selectionMode="single"
            defaultExpandedKeys={["1"]}
            titleWrapper="shadow-md rounded-md border border-gray-200"
          >
            <AccordionItem
              title={
                <div className="flex items-center gap-5 px-5">
                  <img src={person} alt="" />{" "}
                  <span className="text-[#305F32] font-[600]">
                    EMPLOYEE PROFILE SUMMARY
                  </span>
                </div>
              }
              className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
            >
              <MetaData data={employeeData} />
            </AccordionItem>
          </Accordion>
          {allObjectives?.map((item, index) => (
            <Accordion
              aria-label={`Accordion ${index + 1}`}
              key={index + 1}
              selectionMode="single"
              defaultExpandedKeys={["1"]}
              titleWrapper="shadow-md rounded-md border border-gray-200"
            >
              <AccordionItem
                key={index + 1}
                title={
                  <div className="flex items-center justify-between px-5">
                    <div className="flex items-center gap-5">
                      <img src={flag} alt="" />
                      <span className="text-[#4B664C] font-[600]">
                        OBJECTIVE: {item?.objectiveTitle}
                      </span>
                    </div>
                    <div>
                      <span className="text-[#4B664C] font-[600]">
                        Weight: {item?.objectiveWeight}%
                      </span>
                    </div>
                    <div className="w-10" />
                  </div>
                }
                className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
              >
                <div>
                  {item?.krAs?.map((items, kraIndex) => (
                    <Accordion
                      key={kraIndex + 1}
                      aria-label={`Accordion ${kraIndex + 1}`}
                      selectionMode="single"
                      defaultExpandedKeys={["1"]}
                      titleWrapper="shadow-md rounded-md border border-gray-200"
                    >
                      <AccordionItem
                        key={kraIndex + 1}
                        title={
                          <div className="flex items-center gap-5 px-5">
                            <img src={bull} alt="" />
                            <span className="text-[#4B664C] font-[600]">
                              KRA: {items?.kraTitle}
                            </span>
                          </div>
                        }
                        className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                      >
                        <div>
                          {items.isAutoGenerated && (
                            <div className="flex items-center justify-between px-5">
                              <div />
                              <div>
                                <p className="text-[#4B664C] font-[600]">
                                  isAutogenerated
                                </p>
                              </div>
                            </div>
                          )}
                          <div
                            key={kraIndex + 1}
                            className="flex items-center gap-5 py-2 px-5"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "180px 1fr",
                              alignItems: "center",
                              gap: "16px",
                            }}
                          >
                            <h2 className="text-[#305F32] font-[600]">
                              Title: {items.kraTitle}
                            </h2>
                            <h4 className="text-[#305F32] font-[500]">
                              Description: {items.kraDescription}
                            </h4>
                            <h2 className="text-[#305F32] font-[600]">
                              Target: {items.kraTarget}
                            </h2>
                            <h4 className="text-[#00AB09] font-[500]">
                              Score: {items.kraScore || "Not scored yet"}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Measurement Type:{" "}
                              {MeasurementTypeFormatter(items.measurementType)}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Source: {items.source}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              KRA Type: {items.kraType}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Include Self Review:{" "}
                              {items.includeSelfReview ? "Yes" : "No"}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Period Start Date:{" "}
                              {new Date(
                                items.periodStartDate
                              ).toLocaleDateString()}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Period End Date:{" "}
                              {new Date(
                                items.periodEndDate
                              ).toLocaleDateString()}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              Next Due Date:{" "}
                              {new Date(items.nextDueDate).toLocaleDateString()}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              SLA Due Date:{" "}
                              {new Date(items.slaDueDate).toLocaleDateString()}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              SLA Reminder Count: {items.slaReminderCount}
                            </h4>
                            <h4 className="text-[#305F32] font-[500]">
                              SLA Start Duration: {items.slaStartDuration}
                            </h4>
                          </div>
                          {/* <div className="px-5">
                            <div className={DashboardStyle.button_cage}>
                              <button
                                width={"auto"}
                                className={DashboardStyle?.button_cage_weight}
                                onClick={() => {
                                  setAppraisalId(items.kraId);
                                  handleApproveModal();
                                }}
                                type="button"
                              >
                                Approve
                              </button>
                              <ActionButtons
                                width={"auto"}
                                className={DashboardStyle?.button_cage_weight}
                                style={{ backgroundColor: "red" }}
                                onClick={() => {
                                  setAppraisalId(items.kraId);
                                  handleDeclineModal();
                                }}
                                type="button"
                              >
                                Decline
                              </ActionButtons>
                            </div>
                          </div> */}

                          {items?.employeeReviewDetails?.map((item) => (
                            <>
                              {item?.comment && item?.kraActualScore && (
                                <div className="bg-[#f9fbf7] rounded-xl border border-gray-200 p-6 w-full text-base">
                                  <AppraisalReviewDetails
                                    item={item}
                                    showDocument={item?.appraisalType === 1}
                                    peerReviewAffectsScore={
                                      items?.peerReviewAffectsScore
                                    }
                                    upwardReviewAffectsScore={
                                      items?.upwardReviewAffectsScore
                                    }
                                    crossReviewAffectsScore={
                                      items?.crossReviewAffectsScore
                                    }
                                  />
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </AccordionItem>
                    </Accordion>
                  ))}
                </div>
              </AccordionItem>
            </Accordion>
          ))}

          <Accordion
            aria-label={`Accordion 3`}
            selectionMode="single"
            titleWrapper="shadow-md rounded-md border border-gray-200"
          >
            <AccordionItem
              title={
                <div className="flex items-center gap-5 px-5">
                  <img src={person} alt="" />{" "}
                  <span className="text-[#305F32] font-[600]">
                    Comment & Recommendation
                  </span>
                </div>
              }
              className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
            >
              <div className="my-6">
                <FormProvider {...formMethods}>
                  <FormTemplate
                    className={"p-6"}
                    handleSubmit={handleSubmit(submit)}
                  >
                    <div className="grid grid-cols-3 gap-8">
                      <FormTextArea
                        className="h-[200px] col-span-2"
                        title={"Comment"}
                        camelCase={"comment"}
                      />
                      <FormSelect
                        title={"Recommendation"}
                        camelCase={"selectedRecommendation"}
                        placeholder={"Select Recommendation"}
                        array={recommendation?.result
                          ?.filter(
                            (rec) =>
                              Number(totalScore.totalAppraisalScore / maxScore) >= rec.fromScore &&
                              Number(totalScore.totalAppraisalScore / maxScore) <= rec.toScore && rec?.employeeType === employeeType
                          )
                          ?.map((opt) => (
                            <option
                              key={opt.id}
                              value={opt.recommendationTitle}
                            >
                              {opt.recommendationTitle}
                            </option>
                          ))}
                        defaultValue={"Select Recommendation"}
                      />
                    </div>
                    <div
                      style={{ marginTop: "1rem" }}
                      className={DashboardStyle.button_cage}
                    >
                      <ActionButtons
                        isLoading={isLoading}
                        disabled={!isValid}
                        width={"auto"}
                        className={DashboardStyle?.button_cage_weight}
                        bg="var(--primary-color)"
                      >
                        {isLoading ? "Submitting..." : "Submit Review"}
                      </ActionButtons>
                    </div>
                  </FormTemplate>
                </FormProvider>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          // handleComment={handleComment}
          handleDelete={() => declineAction(false)}
          isLoading={isLoading}
          extra={
            <select
              name="select"
              id="selectedRecommendation"
              className="text-xs border border-slate-300 my-2 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
            // onChange={(e) => setSelectedRecommendation(e.currentTarget.value)}
            >
              <option value="">Select recommendation</option>
              {recommendation?.result?.map((opt) => (
                <option key={opt.id} value={opt.recommendationTitle}>
                  {opt.recommendationTitle}
                </option>
              ))}
            </select>
          }
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(true)}
        // handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Appraisal"}
        hasComment={true}
        // disabled={!comment}
        comment={
          <div
            className=" gap-3 w-full space-y-2 px-7 py-7"
            style={{ borderBottom: "1px solid #ccc" }}
          >
            <select
              name="select"
              id="selectedRecommendation"
              className="text-xs border border-slate-300 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
            // onChange={(e) => setSelectedRecommendation(e.currentTarget.value)}
            >
              <option value="">Select recommendation</option>
              {recommendation?.result?.map((opt) => (
                <option key={opt.id} value={opt.recommendationTitle}>
                  {opt.recommendationTitle}
                </option>
              ))}
            </select>
            {/* <textarea
              cols={"15"}
              rows={"5"}
              placeholder="Enter a comment..."
              onChange={handleComment}
              className="text-xs border border-slate-300 rounded w-full p-2 outline-none focus:ring-0 focus:border-customGreen"
            /> */}
          </div>
        }
      />
    </PageLayout>
  );
};
